import { GatsbyBrowser } from "gatsby";
import React from "react";
import App from "./src/templates/app";
import AppPage from "./src/templates/appPage";
import { AppPageContext } from "./src/types/app-types";

type AppBrowser = GatsbyBrowser<Record<string, unknown>, AppPageContext>;

export const wrapRootElement: AppBrowser["wrapRootElement"] = ({ element }) => (
  <App>{element}</App>
);

export const wrapPageElement: AppBrowser["wrapPageElement"] = ({
  element,
  props,
}) => <AppPage {...props}>{element}</AppPage>;
